export const getApiBaseUrl = () => {
  const url = import.meta.env.VITE_API_BASE_URL as string | undefined
  if (url && url.length > 0) {
    return url
  }

  return import.meta.env.DEV ? 'http://localhost:42380' : 'https://api.hikestrong.app'
}

export const resolveMobileWebBaseUrl = (
  url: string | undefined,
  isDevelopment: boolean
): string | null => {
  if (url && url.length > 0) {
    return url
  }

  return isDevelopment ? 'http://localhost:42382' : null
}

export const getMobileWebBaseUrl = (): string | null =>
  resolveMobileWebBaseUrl(
    import.meta.env.VITE_MOBILE_WEB_BASE_URL as string | undefined,
    import.meta.env.DEV
  )

export type DashboardEnvironment = 'live' | 'staging' | 'local' | 'preview'

export const getDashboardEnvironment = (
  hostname = typeof window === 'undefined' ? '' : window.location.hostname
): DashboardEnvironment => {
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '')

  if (normalizedHostname === 'admin.hikestrong.app') {
    return 'live'
  }

  if (normalizedHostname === 'admin-staging.hikestrong.app') {
    return 'staging'
  }

  if (
    normalizedHostname === 'localhost' ||
    normalizedHostname === '127.0.0.1' ||
    normalizedHostname === '::1'
  ) {
    return 'local'
  }

  return 'preview'
}
